// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************

export enum UITheme {
    UI_THEME_DARK = 0,
    UI_THEME_LIGHT = 1,
}

export enum UserViewType {
    USER_VIEW_TYPE_SMB = 0,
    USER_VIEW_TYPE_ADMIN = 1,
}
